import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { isValidNameWithSpace, renderTextArea, renderTextField, renderCheckBox, renderAutoCompleteSingleSelect } from '../../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import { getMasterTherapyById, saveMasterTherapy } from '../actions/MasterTherapyActions';
import validate from '../validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError } from '../../../../../../src/actions/utilAction';
import SmallLoader from '../../../../../img/small-loader.gif';
import * as _  from 'lodash';

const validateOtherTaxonomy = (value) => !(value ? value.trim() : value) ? 'Please enter taxonomy code' : undefined;

class MasterTherapyModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterTherapyId: props.masterTherapyId,
      IsBillable: null,
      Taxonomylist: [{ id: '106S00000X', value: '106S00000X - BT' }, { id: '106E00000X', value: '106E00000X - BCaBA'  },{ id: '103K00000X', value: '103K00000X - BCBA'  },{ id: 'Other', value: 'Other' }],
      displayOtherTaxonomy: false,
    };
    this.debouncedCheckFieldDataExistence = _.debounce(this.checkFieldDataExistence, 1000);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };


  componentWillReceiveProps(nextProps) {
    if (nextProps.masterTherapyDetails && nextProps.masterTherapyDetails !== this.props.masterTherapyDetails) {
      let data = nextProps.masterTherapyDetails.data;
      this.setState({
        displayOtherTaxonomy: ((data.taxonomyCode !== '' && data.taxonomyCode !== undefined && data.taxonomyCode !== '106S00000X' && data.taxonomyCode !== '106E00000X' && data.taxonomyCode !== '103K00000X') ? true : false),
      });
    }

    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }
  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.id) ? this.props.initialValues.id : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  componentWillMount() {
    if (this.props.masterTherapyId) {
      this.props.getMasterTherapyById(this.props.masterTherapyId);
    }
  }
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    if (input.name === 'taxonomyCodeIds') {
      if (selectedRecord.value !== '') {
        if (selectedRecord.value === 'Other') {          
          this.props.dispatch(change('LocationMasterModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: true });
        } else {          
          this.props.dispatch(change('MasterTherapyModalForm', 'taxonomyCode', null));
          this.setState({ displayOtherTaxonomy: false });
        }
      } else {
        
        this.setState({ displayOtherTaxonomy: false });
      }
    }
  }
  onSubmitHandler(formData) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formData.id = this.state.masterTherapyId;
    formData.therapyName = formData.therapyName.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    formData.taxonomyCode = formData.taxonomyCode ? formData.taxonomyCode.trim() : '';    
    formData.isActive = formData.isActive || false;
    formData.taxonomyCode =  this.state.displayOtherTaxonomy ? (formData.taxonomyCode ? formData.taxonomyCode.trim() : '') : (formData.taxonomyCodeIds || '');
    this.props.clearFieldErrorArray();
    this.props.saveMasterTherapy(formData);
    this.setState({ open: false });
    this.props.closeDialog();
  }
  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit, valid } = this.props;
    let submitButton = (this.props.loading || !valid || this.props.checkFieldExistLoading) ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.masterTherapyId ? 'Edit Master Therapy' : 'Add Master Therapy'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="therapyName"
                    type="text"
                    //onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Therapy name')}
                    onChange={(input, value) => this.debouncedCheckFieldDataExistence(input, value, 'Therapy name')}
                    customError={displayCustomError('THERAPYNAME', this.props.fieldError)}
                    maxLength="100"
                    label="Therapy Name"
                    normalize={isValidNameWithSpace}
                    component={renderTextField} />
                </div>
                <div className="col-sm-6 mt-35">
                    <Field
                      name="taxonomyCodeIds"
                      label="Taxonomy Code"
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.Taxonomylist}
                      component={renderAutoCompleteSingleSelect} />
              </div>
              {this.state.displayOtherTaxonomy && <div className="col-sm-12 require">
                  <Field
                      name="taxonomyCode"
                      type="text"
                      maxLength='100'
                      label="Taxonomy Code"                    
                      component={renderTextField} 
                      validate={this.state.displayOtherTaxonomy ? [validateOtherTaxonomy] : null}
                      />
                </div>}
                <div className="col-sm-12 col-md-12">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <Field className="mt20 mb0 custm_check"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}
const selector = formValueSelector('MasterTherapyModalForm');
function mapStateToProps(state, ownProps) {
  let initialValueData = null;
  if (ownProps.masterTherapyId && state.masterTherapy.getMasterTherapyById && state.masterTherapy.getMasterTherapyById.data) {
    initialValueData = state.masterTherapy.getMasterTherapyById.data;
    if(state.masterTherapy.getMasterTherapyById.data.taxonomyCode !== '' && state.masterTherapy.getMasterTherapyById.data.taxonomyCode !== undefined && state.masterTherapy.getMasterTherapyById.data.taxonomyCode !== '106S00000X' && state.masterTherapy.getMasterTherapyById.data.taxonomyCode !== '106E00000X' && state.masterTherapy.getMasterTherapyById.data.taxonomyCode !== '103K00000X') 
    {
      initialValueData.taxonomyCode = state.masterTherapy.getMasterTherapyById.data.taxonomyCode;
      initialValueData.taxonomyCodeIds = 'Other';
    }
    else {      
      initialValueData.taxonomyCodeIds = state.masterTherapy.getMasterTherapyById.data.taxonomyCode;
    }    
  }
  return {
    description: selector(state, 'description'),
    loading: state.masterTherapy.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    masterTherapyDetails: state.masterTherapy.getMasterTherapyById,
    checkFieldExistLoading: state.appConfig.fieldErrorLoading,
  };
}

MasterTherapyModal = reduxForm({
  form: 'MasterTherapyModalForm',
  validate,
  enableReinitialize: true,
})(MasterTherapyModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, saveMasterTherapy, getMasterTherapyById })(MasterTherapyModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterTherapy/components/MasterTherapy_Modal.js